<template>
	<div class="contactus">
		<el-backtop target=".contactus"></el-backtop>
		<div class="pchome-headercon">
			<headers @ChangeEmit="ChangeEmit" ref="head"></headers>
		</div>
		<div id="container"></div>
		<div class="pccontactup">
			<div class="contactup-left">
				<div class="left-container">
					<div class="contaleft-hea">
						{{conuservices}}
					</div>
					<div class="contaraleft-foo">
						{{conanticoniden}}
					</div>
					<div class="contaraleft-foo" v-if="lang === 'cn' ">
						{{contips}}
					</div>
					<div class="contaraleft-foo" v-if="lang === 'cn' ">
						{{concomprob}}
					</div>
					<div class="contaraleft-foo">
						{{contoptitle}}
					</div>
					<div class="contaraleft-foo">
						{{cononlinepreview}}
					</div>
				</div>

				<!--				<div class="contaraleft-foo">-->
				<!--					{{conhaanticoniden}}-->
				<!--				</div>-->
				<!--				<div class="contaraleft-foo">-->
				<!--					{{condadownlo}}-->
				<!--				</div>-->
				<!--				<div class="contaraleft-foo">-->
				<!--					{{conmaintenance}}-->
				<!--				</div>-->

				<!--				<div class="contaraleft-foo">-->
				<!--					{{confoptitle}}-->
				<!--				</div>-->

			</div>
			<div class="contactup-right">
				<el-form :model="formData" ref="formData" :rules="rules" label-width="0" class="demo-ruleForm">
					<div class="right-inputhea">
						<div class="inpputhea-left">
							<div class="inouthea-na">{{conname}}</div>
							<el-form-item prop="name" class="form-item" >
								<el-input v-model="formData.name" :placeholder="pleaseent"></el-input>
							</el-form-item>
						</div>
						<div class="inpputhea-right">
							<div class="inouthea-na">{{concompany}}</div>
							<el-form-item prop="company" class="form-item">
								<el-input v-model="formData.company" :placeholder="pleaseent"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="right-inputhea">
						<div class="inpputhea-left">
							<div class="inouthea-na">{{conphone}}</div>
							<el-form-item prop="phone" class="form-item">
								<el-input v-model="formData.phone" :placeholder="pleaseent"></el-input>
							</el-form-item>
						</div>
						<div class="inpputhea-right">
							<div class="inouthea-na">{{conemail}}</div>
							<el-form-item prop="email" class="form-item">
								<el-input v-model="formData.email" :placeholder="pleaseent"></el-input>
							</el-form-item>
						</div>
					</div>

					<div class="inputfoolan">
						<div class="inouthea-na">{{concountry}}</div>
						<el-form-item prop="country" class="form-item">
							<el-input v-model="formData.country" :placeholder="pleaseent"></el-input>
						</el-form-item>
					</div>

					<div class="teadxty">
						<div class="inouthea-na">{{concontent}}</div>
						<el-form-item prop="content" class="form-item">
							<el-input
									type="textarea"
									:placeholder="pleaseent"
									:rows="4"
									v-model="formData.content">
							</el-input>
						</el-form-item>
					</div>
					<div class="inouthesub" @click="submitForm('formData')" :style="'background:'+$store.state.themeColor">{{conquerysub}}</div>
				</el-form>
			</div>
		</div>
		<div class="questionfeed" id="questionfeed" v-if="false">
			<div class="quetionhea">{{conproblfeedba}}</div>
			<div class="quetionmessage" v-for="(item,index) in eavingmsg">
				<div class="quetionmess-hea">
					<div class="quemesshea-left">{{concontent}}：{{item.content}}</div>
				</div>
				<div class="quetionmess-foo">
					<div class="quemessfoo-left">{{concustomserfeed}}：{{item.feedback}}</div>
				</div>
			</div>
			<el-pagination
					:class="$store.state.brand"
					background
					:page-size="5"
					@current-change="currentPage"
					layout="prev, pager, next"
					:total="eavingtotal">
			</el-pagination>
		</div>
		<footers ref=is_change></footers>
	</div>
</template>
<script>
	import '@/lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
	import headers from '../../common/header.vue'
	import footers from '../../common/footers.vue'
	// import a from 'https://webapi.amap.com/maps?v=1.4.15&key=58a7fdd9749b485055b47d8c70f88670'
	export default{
		data(){
			var checkEmail = (rule, value, callback) => {
				const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/;
				const len = 50
				if(value.length > len){
					return callback(new Error("邮箱地址过长，请重新输入！"));
				}
				if (regEmail.test(value)) {
					console.log(regEmail.test(value));
					return callback();
				} else {
					callback(new Error("请输入正确的邮箱"));
				}
			};
			var checkPhone = (rule, value, callback) => {
				console.log(typeof value, "\\\\/");
				const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
				if (!Number.isInteger(+value)) {
					callback(new Error("请输入数字值"));
				} else {
					if (phoneReg.test(value)) {
						callback();
					} else {
						callback(new Error("电话号码格式不正确"));
					}
				}
			};
			return{
				form: {},
				name:'',
				lang:'',
				eavingtotal:0,
				cccc:'en',
				zmucnt:'桂林啄木鸟医疗器械',
				conuservices:"联系我们",
				conanticoniden:'公司地址:桂林市国家高新区信息产业园',
				//conhaanticoniden:'',
				//	condadownlo:'人力资源邮箱:',
				//conmaintenance:'zmnhr02@glwoodpecker.com',
				concomprob:'客户服务电话: 0773-2350521/13978361362',
				contoptitle:'销售部门电话: 0773--5831172/5835305',
				//confoptitle:'传真:0773-5822450',
				cononlinepreview:'E-mail: woodpecker4@glwoodpecker.com',
				contips:"邮政编码: 541004",
				conquerysub:'提交',
				conname:'姓名',
				concompany:'公司',
				conphone:'电话',
				conemail:'邮箱',
				concountry:'国家',
				concontent:'留言内容',
				conproblfeedba:'问题反馈',
				pleaseent:'请输入',
				concustomserfeed:'客服反馈',
				company:'',
				phone:'',
				email:'',
				country:'',
				content:'',
				id:'',
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				page:1,
				eavingmsg:'',
				options: [{
					value: '选项1',
					label: '啄木鸟官网'
				}, {
					value: '选项2',
					label: '啄木鸟官网1'
				}, {
					value: '选项3',
					label: '啄木鸟官网2'
				}, {
					value: '选项4',
					label: '啄木鸟官网3'
				}, {
					value: '选项5',
					label: '啄木鸟官网4'
				}],
				optionslang: [{
					valuelang: '选项1',
					labellang: 'CN'
				}, {
					valuelang: '选项2',
					labellang: 'EN'
				}],
				value: '',
				valuelang: '',
				tableData: [{
					id: '想了解一下最新款的喷砂洁牙机',
					name: '已转交给业务经理，请注息来电',
				}, {
					id: '想了解一下最新款的喷砂洁牙机',
					name: '已转交给业务经理，请注息来电',
				}, {
					id: '想了解一下最新款的喷砂洁牙机',
					name: '已转交给业务经理，请注息来电',
				}, {
					id: '想了解一下最新款的喷砂洁牙机',
					name: '已转交给业务经理，请注息来电',
				}],
				nav_color:session.get('channel_id')==1?'#c32329':session.get('channel_id')==2?'#304895':'#313131',
				formData:{},
				rules:{
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' },
						{ max: 50,message:'姓名过长，请重新输入！',  trigger: 'blur' }
					],
					company: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' },
						{ max: 50, message:'公司名称过长，请重新输入！', trigger: 'blur' }
					],
					phone: [
						{ required: true, message: '请输入手机号码',trigger: 'blur' },
						{ max: 50, message:'手机号码过长，请重新输入！', trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请输入邮箱',trigger: 'blur' },
						{ validator: checkEmail, trigger: 'blur' }
					],
					country: [
						{ required: true, message: '请输入所在国家名称',trigger: 'blur' },
						{ max: 50, message:'国家过长，请重新输入！', trigger: 'blur' }
					],
					content: [
						{ required: true, message: '请输入留言内容',trigger: 'blur' },
						{ max: 250, message:'内容过长，请重新输入！', trigger: 'blur' }
					],
				},
			}
		},
		components:{
			headers,
			footers
		},
		watch:{
			'$route': 'getParams'
		},
		mounted() {
			this.restForm()
			this.value=this.options[0].label
			this.valuelang=this.optionslang[0].labellang
			this.getParams()
			this.pcgetleavingmsg()
			this.heshow=true
			this.init()
			document.addEventListener('scroll',this.handleScroll,false)
			this.$once('hook:beforeDestroy', () => {
				document.removeEventListener('scroll', this.handleScroll,false)
			})
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				console.log('手机手机21321321')

				this.$router.push({path:'./phcontactus',query:{e:this.$route.query.e}})
			}


			sessionStorage.setItem('page',JSON.stringify({name:'pccontactus',data:false}))
		},
		methods: {
			restForm(){
				this.formData = {
					name:'',
					company:'',
					phone:'',
					email:'',
					country:'',
					content:'',
				}
			},
			init () {
				this.lang = session.get("lang") == '' ? 'cn' : session.get("lang");
				/* {lng:110.343116,lat:25.274862} */
				var map = new AMap.Map('container', {
					resizeEnable: true,
					center: [110.336512,25.269241],
					zoom: 15,
					lang:session.get("lang") == '' ? 'cn' : session.get("lang")
				});
				var marker = new AMap.Marker({
					position: map.getCenter(),
					//  icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
					anchor:'bottom-center',
					offset: new AMap.Pixel(0, 0)
				});

				marker.setMap(map);

				// 设置鼠标划过点标记显示的文字提示
				marker.setTitle('我是marker的title');

				// 设置label标签
				// label默认蓝框白底左上角显示，样式className为：amap-marker-label
				marker.setLabel({
					direction:'right',
					offset: new AMap.Pixel(10, 0),  //设置文本标注偏移量
					content: this.zmucnt, //设置文本标注内容桂林啄木鸟医疗器械
				});
			},
			ChangeEmit(){ //子组件传递
				//主动调用子组件
				this.$refs.is_change.get_index_channel_data();
				this.$refs.is_change.pageParam();
				this.getParams()
				this.pcgetleavingmsg()
				this.pageParam() //页面静态参数
				this.init()
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let data={
							channel_ids: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
							name:this.formData.name,
							company:this.formData.company,
							phone:this.formData.phone,
							email:this.formData.email,
							country:this.formData.country,
							content:this.formData.content,
							lang: this.lang
						}
						this.$api.leaving_msg(data).then((res) => {
							if (res.code == 1) {
								this.$message({
									message: res.msg,
									type: "success",
								});
								this.restForm()
							} else {
								this.$message.error(res.msg);
							}
						});
					} else {
						return false;
					}
				});
			},
			onSubmit() {
				let data={
					channel_ids: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					name:this.name,
					company:this.company,
					phone:this.phone,
					email:this.email,
					country:this.country,
					content:this.content,
					lang: this.lang
				}
				this.$api.leaving_msg(data).then((res) => {
					if (res.code == 1) {
						this.$message({
							message: res.msg,
							type: "success",
						});
						this.form = {};
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			pcgetleavingmsg(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:this.page,
					pageSize:5,
				}
				this.$api.get_leaving_msg(data).then((res) => {
					this.eavingmsg=res.data.data
					console.log('eavingmsg',this.eavingmsg)
					this.eavingtotal=res.data.total
				});
			},
			currentPage(e){
				this.page=e
				this.pcgetleavingmsg()
			},
			handleScroll () {
				let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
				this.$refs.head.scrollTop_change(scrollTop)
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.conuservices = "联系我们"
					this.zmucnt='桂林啄木鸟医疗器械'
					this.conanticoniden='公司地址:桂林市国家高新区信息产业园',
							//this.conhaanticoniden='空间信息工业园',
							//this.condadownlo='人力资源邮箱:',
							//this.conmaintenance='zmnhr02@glwoodpecker.com',
							this.concomprob='客户服务电话: 0773-2350521/13978361362',
							this.contoptitle='销售部门电话: 0773--5831172/5835305'
					//	this.confoptitle='传真:0773-5822450'
					this.cononlinepreview='E-mail: woodpecker4@glwoodpecker.com'
					this.contips="邮政编码: 541004"
					this.conquerysub="提交"
					this.conname='姓名'
					this.concompany='公司'
					this.conphone='电话'
					this.conemail='邮箱'
					this.concountry='国家'
					this.concontent='留言内容'
					this.conproblfeedba='问题反馈'
					this.pleaseent='请输入'
					this.concustomserfeed='客服反馈'
				}else{
					this.conuservices = "CONTACT US"
					this.zmucnt='Guilin woodpecker medical equipment'
					this.conanticoniden='Address: Information Industrial Park,Guilin National High-Tech Zone,Guilin,Guangxi, 541004 P.R.China',
							//this.conhaanticoniden='Company address: Guilin National High Tech Enterprise',
							//this.condadownlo='HR email:',
							//this.conmaintenance='zmnhr02@glwoodpecker.com',
							this.concomprob='Customer service Tel.: 0773-2350521 / 13978361362',
							this.contoptitle='Sales Dept：+86-773-5873196'
					//this.confoptitle='Fax: 0773-5822450'
					this.cononlinepreview='E-mail: woodpecker4@glwoodpecker.com'
					this.contips="Postal Code: 541004"
					this.conquerysub="submit"
					this.conname='Name'
					this.concompany='Company'
					this.conphone='Telephone'
					this.conemail='E-mail'
					this.concountry='Country'
					this.concontent='Content'
					this.conproblfeedba='Feedback '
					this.pleaseent='Please enter'
					this.concustomserfeed='Customer service feedback'
				}
			},
			hometo(){
				this.$router.push({path: '/pchome'})
			},
			videoto(){
				this.$router.push({path: '/pcvideos'})
			},
			queryto(){
				this.$router.push({path: '/pcquerys'})
			},
			productto(){
				this.$router.push({path: '/pcproduct'})
			},
			elitesto(){
				this.$router.push({path: '/pcelites'})
			},
			contactusto(){
				this.$router.push({path: '/pccontactus'})
			},
			aboutto(){
				this.$router.push({path: '/pcabout'})
			},
			seachto(){
				this.$router.push({path: '/pcseachs'})
			},
			nextimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index == 0){
					this.current_index = l-1;
					scroll.scrollLeft = diatance;
				}else{
					this.current_index--;
					scroll.scrollLeft -= diatance / (l - 1);
				}
			},
			preimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index+1 == l){
					this.current_index = 0;
					scroll.scrollLeft = 0;
				}else{
					this.current_index++;
					scroll.scrollLeft += diatance / (l - 1);
				}
			},
			enter(index){
				this.navheader= true;
			},
			playenterli(){
				this.playli=false
			},

			playenterri(){
				this.playri=false
			},
			playleaveli(){
				this.playli=true
			},
			playleaveri(){
				this.playri=true
			},
			getParams () {
				this.id = this.$route.query.e
				var selectId = this.$route.query.e == 2 ? 'questionfeed'  : 'container'
				this.$refs.is_change.scrollIntoView(selectId)
			}

		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
		background: #fff;
	}
	.contactus{
		width: calc(100vw);
		height: calc(100vh);
		/* overflow-x: hidden; */
		position: relative;
		background: #fff;
	}
	.pchome-headercon{
		width: 100vw;
		position: relative;
		background-size: 100% 100%;
		padding-top: 79px;
		box-sizing: border-box;
	}

	.checse{
		margin-top: 0 !important;
	}
	.product-title{
		color: #fff;
		margin-top: 249px;
		margin-left: 240px;
	}
	.title-hea{
		font-size: 20px;
		font-weight: normal;
		letter-spacing: 1px;
	}
	.title-model{
		margin-top: 15px;
		margin-bottom: 15px;
		font-size: 44px;
		font-weight: normal;
		letter-spacing: 2px;
	}
	.product-but{
		margin-top: 40px;
		font-size: 16px;
		width: 110px;
		height: 46px;
		background: #E31E24;
		border-radius: 23px;
		line-height: 46px;
		text-align: center;
		cursor: pointer;
		font-size: 16px;
	}
	/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0;
	} */
	.nav-wit{

	}
	.nav-left{
		width: 100px;
		height: 50px;
	}
	.nav-left img{
		width: 100%;
		height: 100%;
	}
	/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */

	.nav-center-item:first-child{
		margin-left: 0;
	}
	.nav-right{
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		font-weight: 400;
		margin-left: 180px;
	}
	.nav-right .search{
		width: 20px;
		height: 20px;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .search img{
		width: 100%;
		height: 100%;
	}
	.nav-right .homename{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .homename img{
		width: 16px;
		height: 16px;
		margin-left: 4px;
	}
	.nav-right .language{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.nav-right .language img{
		width: 16px;
		height: 16px;
		margin-left: 6px;
	}

	.bb{
		background: #FAFAFA;
		position: fixed;
		top: 0;
		z-index: 99;
	}
	.aboutitem-hea{
		margin-top: 80px;
		margin-bottom: 40px;
		height: 33px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		letter-spacing: 1px;
	}
	.aboutitem-fooitem{
		margin-bottom: 10px;
	}
	.fooitem-left{
		width: 110px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		justify-content: center;


		font-size: 16px;
		font-weight: 400;
		color: #FAFAFA;
		margin-right: 20px;
	}
	.fooitem-left img{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.aboutitem-foosus{
		display: flex;
		margin-bottom: 20px;
	}
	.fooitem-right{
		font-size: 16px;
		font-weight: 400;
		color: #CCCCCC;
	}
	.fooitem-cont{
		margin-top: 25px;
		margin-left: 40px;
	}
	.fooitem-cont:first-child{
		margin-left: 0px;
	}
	.fooite-img{
		display: flex;
	}
	.fooite-img img{
		width: 90px;
		height: 90px;
	}
	.fooite-nam{
		text-align: center;
		margin-top: 20px;
	}
	.right-tit{
		margin-bottom: 5px;
	}
	.homefoot{

		height: 94px;
		background: #272727;
		border-top: 2px solid #666;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.foot-hea{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
	}
	.foot-f{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.map{
		width: 100%;
		height: 649px;
	}
	.pccontactup{
		display: flex;
		background-color: #ffffff;
	}
	.contactup-left{
		padding-left: 260px;
		padding-top: 60px;
		width: 940px;
		background: #FAFAFA;
		box-sizing: border-box;
	}
	.left-container {
		width: 500px;
	}
	.contaleft-hea{
		margin-bottom: 40px;
		/* width: 169px; */
		height: 56px;
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		line-height: 56px;
		letter-spacing: 2px;
	}
	.contaraleft-foo{
		font-size: 24px;
		font-weight: 400;
		color: #5d5f5f;
		margin-bottom: 20px;
	}
	.right-inputhea{
		display: flex;
		font-size: 24px;
		font-weight: 500;
		color: #5d5f5f;

	}
	.inouthea-na{
		margin-left: 40px;
	}
	.right-inputhea input{
		width: 340px;
		height: 50px;
		border: none;
		border-bottom: 1px solid #ccc;
		/*margin-left: 40px;*/
		margin-top: 20px;
		/*margin-bottom: 24px;*/
		border-radius: 0;

	}
	.right-inputhea input:focus-visible {
		outline: none;
	}
	/* input{
		margin-top: 20px;
		margin-bottom: 24px;
	} */
	.inputfoolan{
		font-size: 24px;
		font-weight: 400;
		color: #5d5f5f;
	}

	.inputfoolan input{
		outline: none;
		width: 720px;
		height: 50px;
		border: none;
		border-bottom: 1px solid #ccc;
		border-radius: 0;
	}
	.teadxty{
		/* font-size: 24px; */
		margin-top: 20px;
		font-size: 24px;
		font-weight: 400;
		color: #5d5f5f;
		/* width: 680px;
		margin-top: 20px;
		font-size: 24px;
		font-weight: 400;
		color: #5d5f5f;
		overflow: hidden; */
	}
	.teadxty textarea{
		margin-top: 20px;
		border: none;
		width: 720px;
		/*height: 110px;*/
		border-bottom: 1px solid #ccc;
		background: #FFFFFF;
		border-radius: 0;
		padding: 5px 0!important;
		/* max-width: 680px;
		width: 680px;
		height: 110px;
		background: #FFFFFF;
		margin-left: 40px;
		border: none;
		border-bottom: 1px solid #ccc; */
	}
	.contactup-right input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
		/* WebKit browsers */
		/* placeholder颜色  */
		color: #999!important;
		/* placeholder字号  */
		font-size: 18px;


	}
	.contactup-right input::-webkit-input-placeholder, textarea:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #999!important;
		font-size: 18px;

	}
	.contactup-right input::-webkit-input-placeholder, textarea::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #999!important;
		font-size: 18px;
	}
	.contactup-right input::-webkit-input-placeholder, textarea::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #999!important;
		font-size: 18px;
	}


	textarea:focus-visible {
		outline: none;
	}
	.contactup-right{
		padding-top: 60px;
		background-color: #ffffff;
    padding-bottom: 60px;
	}
	.inouthesub{
		width: 110px;
		height: 46px;
		background: #E31E24;
		border-radius: 23px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
		margin-top: 24px;
		margin-left: 40px;
		cursor: pointer;
	}
	.BMap_cpyCtrl{
		display: none !important;
	}
	.questionfeed{
		width: 1400px;
		display: flex;
		align-items: center;
		flex-direction: column;
		padding: 0 260px;
		padding-top: 30px;
	}
	.quetionhea{
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
		display:flex;
		align-items: center;
		justify-content: center;
		margin-top: 60px;
	}
	.quetionmessage{
		width: 1400px;
		background: #FAFAFA;
		padding-left: 40px;
		padding-bottom: 24px;
		box-sizing: border-box;
		margin-top: 20px;

	}
	.quetionmess-hea{
		display: flex;
		font-size: 24px;
		font-weight: 500;
		color: #999;
		letter-spacing: 1px;
		margin-top: 24px;
	}
	.quemesshea-left{
		font-size: 24px;
		font-weight: 500;
		color: #333;
		letter-spacing: 1px;

	}
	.quetionmess-foo{
		display: flex;
		font-size: 18px;
		font-weight: 400;
		color: #999;
		margin-top: 16px;
	}
	.quemessfoo-left{
		color: #D03E3D;
		font-weight: 400;
	}
	.el-pagination{
		margin-top: 50px;
	}

	.el-pagination.woodpecker .el-pager li:not(.disabled).active{
		background-color: #e62129;

	}
	.el-pagination.dte .el-pager li:not(.disabled).active{
		background-color: #1a4698;

	}
	.el-pagination.dba .el-pager li:not(.disabled).active{
		background-color: #5d5f5f;

	}
	.el-pager{
	}
	.number {
		border-radius: 5px;
	}
	.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
		border-radius: 9px;
		width: 48px;
		height: 48px;
		line-height: 48px;
		font-size: 21px;
		color: #666;
	}
	.el-icon-arrow-right:before{

	}
	.el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
		font-size: 24px;
	}
	.anchorBL{
		display: none;
	}
	/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0;
	} */
	.nav-wit{

	}
	.nav-left{
		width: 100px;
		height: 50px;
	}
	.nav-left img{
		width: 100%;
		height: 100%;
	}
	/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */

	.nav-center-item:first-child{
		margin-left: 0;
	}
	.nav-right{
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		font-weight: 400;
		margin-left: 180px;
	}
	.nav-right .search{
		display: flex;
		align-items: center;
		width: 20px;
		height: 20px;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .search img{
		width: 100%;
		height: 100%;
	}
	.nav-right .homename{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .homename img{
		width: 16px;
		height: 16px;
		margin-left: 4px;
	}
	.nav-right .language{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.nav-right .language img{
		width: 16px;
		height: 16px;
		margin-left: 6px;
	}
	#container {
		width: 1920px;
		height: 649px;
	}
	.amap-copyright{
		display: none !important;
	}
	.amap-logo{
		display: none !important;
	}
	.form-item {
		padding-left: 40px;
		margin-top: 10px;
	}
	.form-item input {
		padding: 0!important;
	}
	.form-item .el-form-item__error {
		font-weight: 400;
	}
</style>
